export enum DndItemTypes {
	EDITOR_THUMBNAIL = 'EDITOR_THUMBNAIL',
	DRIVE_ITEM = 'DRIVE_ITEM',
	EDITABLE_SLIDE = 'EDITABLE_SLIDE',
	NATIVE_FILE = '__NATIVE_FILE__',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/typings/dnd.ts